import React from 'react'
import PropTypes from 'prop-types'

class ProgramDirectorSelect extends React.Component {
  state = {
    programDirectorId: this.props.programDirectorId
  }

  onProgramDirectorChange = (e) => {
    this.setState({ programDirectorId: e.target.value })
    setTimeout(function() { this.props.newProgramDirectorCallback(this.state.programDirectorId) }.bind(this), 50)
  }

  render() {
    return(
      <div className={this.props.selectClassName}>
        <select className='form-control'
                title='Program Director'
                value={this.state.programDirectorId}
                onChange={(e) => this.onProgramDirectorChange(e)}>
          <option value=''>
            All Program Directors
          </option>
          {this.props.programDirectors.map((programDirector) =>
            <option
              key={programDirector.id}
              value={programDirector.id}
            >
              {this.props.isSaiAdmin ? programDirector.full_name_reverse_with_account : programDirector.full_name_reverse}
            </option>
          )}
        </select>
      </div>
    )
  }
}

ProgramDirectorSelect.propTypes = {
  program_director_id: PropTypes.number,
  program_directors: PropTypes.array,
  selectClassName: PropTypes.string,
  isSaiAdmin: PropTypes.bool
}

export default ProgramDirectorSelect
